import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ChiefComplaint } from '../../model/chiefComplaint'
import {
	ExamMedicalReport,
	ExamSurgery,
	GoalV2,
	Order,
	OtherTest,
	Procedure,
	ScreeningProcedure,
} from '../../model/exam'
import { Diagnosis } from '../../components/AssessmentAndPlan/types'

export type InvalidActionState = {
	updatingSection: EdgySections
	sectionWithDeletedItem: EdgySections
	snapshotOfContent: SnapshotContent
	invalidActionModal: boolean
	isEditingAfterInvalidAction: boolean
}

export type EdgySections =
	| 'chiefComplaintCategories'
	| 'attachments'
	| 'immunizations'
	| 'surgeries'
	| 'otherTest'
	| 'diagnosis'
	| 'procedures'
	| 'screeningProcedures'
	| 'goals'
	| 'medicalReports'
	| 'orders'
	| ''

export type SnapshotContent =
	| ChiefComplaint
	| ExamSurgery
	| OtherTest
	| Diagnosis
	| ScreeningProcedure
	| GoalV2
	| Order
	| Procedure
	| ExamMedicalReport
	| {}

const initialState: InvalidActionState = {
	updatingSection: '',
	sectionWithDeletedItem: '',
	snapshotOfContent: {},
	invalidActionModal: false,
	isEditingAfterInvalidAction: false,
}

export const invalidActionSlice = createSlice({
	name: 'invalidAction',
	initialState,
	reducers: {
		updatingContent: (
			state,
			{
				payload,
			}: PayloadAction<
				Omit<
					InvalidActionState,
					| 'invalidActionModal'
					| 'isEditingAfterInvalidAction'
					| 'sectionWithDeletedItem'
				>
			>,
		) => {
			state.updatingSection = payload.updatingSection
			state.snapshotOfContent = payload.snapshotOfContent
		},
		deletingContent: (
			state,
			{
				payload,
			}: PayloadAction<
				Omit<
					InvalidActionState,
					| 'invalidActionModal'
					| 'isEditingAfterInvalidAction'
					| 'updatingSection'
					| 'snapshotOfContent'
				>
			>,
		) => {
			state.sectionWithDeletedItem = payload.sectionWithDeletedItem
		},
		setInvalidActionModal: (state, { payload }: PayloadAction<boolean>) => {
			state.invalidActionModal = payload
		},
		setIsEditingAfterInvalidAction: (
			state,
			{ payload }: PayloadAction<boolean>,
		) => {
			state.isEditingAfterInvalidAction = payload
		},
		resetEditingState: state => {
			state.invalidActionModal = false
			state.isEditingAfterInvalidAction = false
			state.updatingSection = ''
			state.sectionWithDeletedItem = ''
			state.snapshotOfContent = {}
		},
	},
})

export const { updatingContent, setInvalidActionModal, resetEditingState } =
	invalidActionSlice.actions

export const invalidAction = invalidActionSlice.reducer
